@if (isNewUI()) {
    <div class="text">
        One or more creatives are being used by the following campaign(s). They need to be disconnected
        before the version can be deleted.
    </div>
    <div class="campaigns">
        @for (campaign of campaigns; track campaign.id) {
            <div
                uiLink
                (click)="openCampaign(campaign.id)"
                [uiTooltip]="'Open campaign in a new tab'">
                {{ campaign.name }}
            </div>
        }
    </div>
} @else {
    <div class="campaigns">
        <div class="text">
            One or more creatives are being used by a campaign. You need to disconnect it/them before
            it/they can be deleted.
            <br /><br />
            Creative(s) is/are used in:<br />
        </div>

        @for (campaign of campaigns; track campaign.id) {
            <div class="campaign">
                <div
                    class="link"
                    (click)="openCampaign(campaign.id)"
                    [uiTooltip]="'Open campaign in a new tab'">
                    <ui-svg-icon icon="campaigns-s"></ui-svg-icon> {{ campaign.name }}
                </div>
            </div>
        }
    </div>

    <ui-dialog-buttons>
        <ui-button
            text="Cancel"
            (click)="cancel()" />
    </ui-dialog-buttons>
}
